// extracted by mini-css-extract-plugin
export default {"downloadPracto":"DownloadPracto_downloadPracto__JUmt3","heading":"DownloadPracto_heading__VwRsn"};